function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomParkViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 2H3c-.55 0-1 .45-1 1v26c0 .55.45 1 1 1h26c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-1 2v20.01c-1.24-.84-2.56-1.52-4-2.02v-6.13c1.72-.45 3-2 3-3.86V9c0-2.21-1.79-4-4-4s-4 1.79-4 4v3c0 1.86 1.28 3.41 3 3.86v5.57c-.8-.17-1.63-.3-2.5-.37V20H21v-2h-1.5v-2c0-1.1-.9-2-2-2h-7c-1.1 0-2 .9-2 2v2H7v2h1.5v1H6.96a3.9 3.9 0 00-1.09-.68c-.6-.24-1.24-.33-1.87-.3V4h24zm-5 10c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v3c0 1.1-.9 2-2 2zm-5.5 4h-7v-2h7v2zm0 2v1h-7v-1h7zM4 22.02c.39-.03.77.02 1.11.15.36.15.67.4.89.79V23h.02c.08.15.15.32.19.51.06.26.23.48.45.62.23.14.5.18.76.11.91-.23 1.57-.16 2.01.09.42.24.85.75 1.07 1.86.09.47.5.8.98.8.91 0 1.34.22 1.57.45.12.12.23.3.3.55H4v-5.98.01zM15.41 28c-.12-.74-.39-1.42-.91-1.95-.58-.59-1.35-.9-2.22-1.01-.27-.85-.7-1.54-1.29-2.05h7c4.07 0 7.24 1.3 10 3.49v1.51H15.4l.01.01z",
    fill: props.color
  }));
}

export default SvgIconRoomParkViewFilled;